<div class="container">
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">
        {{'Explanation Platform' | translate}}
      </h1>
    </div>

    <div class="page-body">

      <div class="content-wrapper">

        <div class="content">

          <div *ngIf="translate.getDefaultLang() == 'nl'" class="text-nl">

              <p>Meet the Youngsters is hét online carrière platform
                voor young professionals, studenten en alumni. Het carrière platform dat je de mogelijkheid biedt om in contact te komen
                met innovatieve en inspirerende werkgevers binnen Limburg.
              </p>

              <p><strong>Hoe werkt Meet the Youngsters?</strong></p>

              <ol>
                <li>Je maakt eerst een persoonlijk profiel aan op het
                platform. Dit doe je door te klikken op ‘start hier’ op de homepage.</li>
                <li>Vul je profiel zo goed mogelijk in (denk
                bijvoorbeeld aan welke opleidingen je gevolgd hebt, opgedane werkervaring
                en vakgebieden waar je interesse in hebt, maar ook de matchingtest).</li>
                <li>Via dit profiel word je gematched met bedrijven
                die aansluiten bij jouw beroepsinteresses en studie. Dus hoe completer je
                profiel, hoe beter de matches zullen zijn!</li>
                <li>Als je interesse hebt om in contact te komen met
                een werkgever stuur je een netwerkverzoek. Andersom kan een bedrijf ook
                interesse in jou tonen.</li>
                <li>Mocht de interesse wederzijds zijn, dan kom je in
                elkaars netwerk.</li>
                <li>Vanuit deze positie kun je contact met elkaar
                opnemen en je carrière uitstippelen bij een van de Limburgse topwerkgevers.
                </li>
              </ol>

          </div>

          <div *ngIf="translate.getDefaultLang() == 'en'" class="text-en">


              <p>Meet the youngsters is the online career platform for young
                professionals, students, and alumni. The career platform that offers you the
                opportunity to get in touch with innovative and inspiring employers within
                Limburg.</p>

              <p><strong>How does Meet the Youngsters work?</strong></p>

            <ol>
              <li>
                You first create a personal profile on the platform. You do
                this by clicking on “start here” on the homepage.
              </li>
              <li>
                Fill in your profile as accurately as possible (for example,
                what courses you have followed, gained work experience and fields you are
                interested in, but also the matching test).
              </li>
              <li>
                Via this profile, you will be matched with companies that match
                your professional interests and study. So the more complete your profile, the
                better the matches will be!
              </li>
              <li>
                If you are interested in getting in touch with a particular
                employer, send a network request. Conversely, an employer can also show
                interest in you.
              </li>
              <li>
                If the interest is mutual, you will join each other’s network.
              </li>
              <li>
                From this position, you can contact each other and plan your
                career with one of the top Limburg employers.
              </li>
            </ol>

          </div>

        </div>

      </div>


    </div>
  </div>
</div>


